<router-outlet></router-outlet>
@if (_loaderService.isLoading$ | async) {
  <app-loader-page></app-loader-page>
}
